import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a21022aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simple-sku-detail-box" }
const _hoisted_2 = { class: "sku-value-box" }
const _hoisted_3 = { class: "sku-value-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangePrice = _resolveComponent("ChangePrice")!
  const _component_ChangeStock = _resolveComponent("ChangeStock")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.editing == 'price')
      ? (_openBlock(), _createBlock(_component_ChangePrice, {
          key: 0,
          modelValue: _ctx.editingRow,
          hideEvent: _ctx.hideEvent,
          onSuccess: _ctx.successEvent,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = ''))
        }, null, 8, ["modelValue", "hideEvent", "onSuccess"]))
      : (_ctx.editing == 'stock')
        ? (_openBlock(), _createBlock(_component_ChangeStock, {
            key: 1,
            modelValue: _ctx.editingRow,
            hideEvent: _ctx.hideEvent,
            onSuccess: _ctx.successEvent,
            onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editing = ''))
          }, null, 8, ["modelValue", "hideEvent", "onSuccess"]))
        : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 2,
            data: _ctx.skuRows,
            border: "",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "规格",
                "min-width": "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.name || `规格${row.index + 1}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "价格",
                width: "150"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(row.price), 1),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (_ctx.edit(row, 'price'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("修改")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "库存",
                width: "150"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(row.stock), 1),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (_ctx.edit(row, 'stock'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("修改")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ])
  ]))
}